import React from "react";

function PanelOverlay({ side, onClose, children }) {
  return (
    <>
      {/* Backdrop — tapping / clicking anywhere outside the panel closes it,
          matching the workflow-builder mobile drawer behaviour. */}
      {onClose && (
        <div
          aria-hidden="true"
          onClick={onClose}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1999, // just below .panel-overlay (z-index: 2000)
            background: 'rgba(0, 0, 0, 0.4)',
          }}
        />
      )}

      <div className={`panel-overlay ${side}`}>
        {/* No close button here — it lives in PanelShell's header */}
        <div
          className="themed-panel-content"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            padding: 0,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}

export default PanelOverlay;
